module.exports = __webpack_public_path__ + "img/welcome_shop.5fd8c014.jpg";